import { getRequest, postRequest } from "../../config/axiosConfig";

export const getAdminLoginHistory = async ({fromDate, toDate, page = 1, limit = 10 }) => {

 
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + `login-history/admin?page=${page}&limit=${limit}&from_date=${fromDate}&to_date=${toDate}`,
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "login history retrieved Successfully!",
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "failed login history retrival request.",
    };
  }
};